import { canAccess } from "utils/canAccess";
import { useAuth } from "store/auth";

export default function useCanAccess() {
  const auth = useAuth();
  const permissions = auth?.userMeta?.role?.permissions;

  return (resource, action) => canAccess(permissions, resource, action);
}
